<ng-container [ngSwitch]="view">
    <ms-pair-game-no-scoreboard
        class="card-scoreboard pair-game-no-scoreboard"
        *ngSwitchCase="viewType.Empty"
        [event]="event"></ms-pair-game-no-scoreboard>
    <ms-pair-game-scoreboard class="card-scoreboard" *ngSwitchCase="viewType.PairGame" [event]="event"></ms-pair-game-scoreboard>
    <ms-set-game-scoreboard class="card-scoreboard set-game-scoreboard" *ngSwitchCase="viewType.SetGame" [event]="event"></ms-set-game-scoreboard>
    <ms-tournament-scoreboard class="card-scoreboard" *ngSwitchCase="viewType.Tournament" [event]="event"></ms-tournament-scoreboard>
</ng-container>
